import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Safari = ({ ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.7708 6.68184C17.9908 6.3808 17.6163 6.00526 17.3146 6.22443L10.5 10.5C10.4475 10.5382 10.4099 10.5887 10.388 10.6443L6.2292 17.3182C6.00922 17.6192 6.38375 17.9947 6.68538 17.7756L13.5 13.5C13.5525 13.4618 13.5901 13.4113 13.612 13.3557L17.7708 6.68184Z'
      fill='currentColor'
    />
  </IconBase>
);
